module.exports = __webpack_public_path__ + "img/artificial.daf38c66.svg";